module.exports = __webpack_public_path__ + "img/visa.162f3b74.svg";